module.exports = __webpack_public_path__ + "img/damagechart.60514b14.jpg";